<template>
  <div class="paragraphs" v-html="gbl.content.statement">
  </div>
</template>

<script>
  export default {
    name: 'StatementPage',
    data() {
      return {
        gbl
      }
    },
  }
</script>


// WEBPACK FOOTER //
// resources/js/pages/StatementPage.vue